/*
  Cart page behaviour for sections/pf-cart.liquid.

  Quantity steppers, removes and cross-sell adds hit the AJAX cart
  (/cart/change.js, /cart/add.js); after each one the section is re-rendered
  through the Section Rendering API (/cart?section_id=pf-cart) and swapped in,
  so every line total, the summary, the "In cart" pills and the header badge
  update without a reload. Order attributes (PO number, company) and the note
  are saved with /cart/update.js as the buyer types so they survive an express
  checkout as well as the normal Checkout button. Cross-sell cards come from
  Shopify's complementary recommendations for the first line, falling back to
  the collection rendered by Liquid.
*/
(function () {
  'use strict';

  var SECTION = 'pf-cart';
  var COUNT_SELECTORS = '.cart-products-count, [data-cart-count], .cart-count, .cart_count, .cartCount, .cart-count-bubble, .header-cart .count, .cart .count, .cart-quantity';
  var pending = 0;

  function root() { return document.getElementById('shopify-section-' + SECTION) || document.querySelector('[data-pf-cart]'); }
  function status(text) {
    var live = document.querySelector('[data-pf-cart-status]');
    if (live) live.textContent = text;
  }
  function setCount(n) {
    Array.prototype.forEach.call(document.querySelectorAll(COUNT_SELECTORS), function (el) { el.textContent = n; });
  }
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* Re-render the section and swap it in, keeping typed attribute values. */
  function rerender(message) {
    var host = document.getElementById('shopify-section-' + SECTION);
    var typed = {};
    document.querySelectorAll('[data-pf-attr]').forEach(function (el) { typed[el.name] = el.value; });
    var quoteOpen = document.querySelector('#pfb-quote-form.is-open');
    return fetch('/cart?section_id=' + SECTION, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('shopify-section-' + SECTION) || doc.body;
        if (host) host.innerHTML = fresh.innerHTML; else return;
        document.querySelectorAll('[data-pf-attr]').forEach(function (el) { if (typed[el.name] !== undefined) el.value = typed[el.name]; });
        if (quoteOpen) openQuote(true);
        var wrap = document.querySelector('[data-pf-cart]');
        if (wrap) setCount(wrap.getAttribute('data-count') || '0');
        syncQuoteFields();
        loadRecommendations();
        applyContinueLink();
        if (message) status(message);
      });
  }

  function busy(line, on) {
    var li = document.querySelector('.pfb-cart-line[data-line="' + line + '"]');
    if (li) li.classList.toggle('is-busy', !!on);
  }

  function change(line, qty, label) {
    pending++;
    busy(line, true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (cart) {
        return rerender(qty === 0 ? label + ' removed. ' + cart.item_count + ' items in cart.' : label + ' quantity set to ' + qty + '. Subtotal ' + money(cart.total_price) + '.');
      })
      .catch(function () { busy(line, false); status('Sorry, that change did not go through. Please try again.'); })
      .then(function () { pending--; });
  }

  function add(variantId, btn) {
    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = 'Adding…';
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (item) { return rerender(item.product_title + ' added to cart.'); })
      .catch(function () { btn.disabled = false; btn.textContent = original; status('Sorry, that item could not be added.'); });
  }

  /* Order attributes + note: saved on change so express checkout gets them too. */
  var attrTimer;
  function saveAttributes() {
    clearTimeout(attrTimer);
    attrTimer = setTimeout(function () {
      var attributes = {};
      var note = null;
      document.querySelectorAll('[data-pf-attr]').forEach(function (el) {
        var m = el.name.match(/^attributes\[(.+)\]$/);
        if (m) attributes[m[1]] = el.value; else if (el.name === 'note') note = el.value;
      });
      var body = { attributes: attributes };
      if (note !== null) body.note = note;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).catch(function () {});
      syncQuoteFields();
    }, 400);
  }

  /* Copy the PO / company into the quote form's hidden fields. */
  function syncQuoteFields() {
    var po = document.getElementById('pfb-po');
    var co = document.getElementById('pfb-company');
    var qpo = document.querySelector('[data-pf-quote-po]');
    var qco = document.querySelector('[data-pf-quote-company]');
    if (po && qpo) qpo.value = po.value;
    if (co && qco) qco.value = co.value;
  }

  function openQuote(silent) {
    var form = document.getElementById('pfb-quote-form');
    var btn = document.querySelector('[data-pf-quote-open]');
    if (!form) return;
    form.classList.add('is-open');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    syncQuoteFields();
    if (!silent) {
      form.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      var first = form.querySelector('input:not([type=hidden])');
      if (first && !first.value) first.focus(); else { var email = form.querySelector('input[type=email]'); if (email) email.focus(); }
    }
  }
  function closeQuote() {
    var form = document.getElementById('pfb-quote-form');
    var btn = document.querySelector('[data-pf-quote-open]');
    if (form) form.classList.remove('is-open');
    if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
  }

  /* Shopify redirects back with ?contact_posted=true after the contact form. */
  function showQuoteSent() {
    if (!/[?&]contact_posted=true/.test(location.search)) return;
    var help = document.querySelector('[data-pf-quote-help]');
    var ok = document.querySelector('[data-pf-quote-ok]');
    if (help) help.hidden = true;
    if (ok) { ok.hidden = false; status(ok.textContent); }
    var org = document.querySelector('.pfb-cart-org');
    if (org) org.scrollIntoView({ block: 'center' });
  }

  /* "Continue shopping" goes back to the last collection the buyer visited. */
  function applyContinueLink() {
    var last = null;
    try { last = localStorage.getItem('pf:lastCollection'); } catch (e) {}
    if (!last && /\/collections\/[^/?#]+/.test(document.referrer)) {
      try { var u = new URL(document.referrer); if (u.origin === location.origin) last = u.pathname; } catch (e) {}
    }
    if (!last) return;
    document.querySelectorAll('[data-pf-continue]').forEach(function (a) { a.setAttribute('href', last); });
  }

  /* Cross-sell: complementary recommendations for the first line, else the Liquid fallback stays. */
  function loadRecommendations() {
    var box = document.querySelector('[data-pf-xsell]');
    if (!box || !window.fetch) return;
    var pid = box.getAttribute('data-product-id');
    if (!pid) return;
    var inCart = Array.prototype.map.call(document.querySelectorAll('.pfb-cart-line'), function (li) { return li.getAttribute('data-variant'); });
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=4&intent=complementary', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var products = (data.products || []).filter(function (p) { return p.variants && p.variants.length; }).slice(0, 4);
        if (!products.length) return;
        var grid = box.querySelector('[data-pf-xsell-grid]');
        grid.innerHTML = products.map(function (p) {
          var v = p.variants.find(function (x) { return x.available; }) || p.variants[0];
          var img = p.featured_image ? '<img src="' + p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2') + '" alt="" loading="lazy">' : '';
          var cta;
          if (inCart.indexOf(String(v.id)) > -1) cta = '<span class="pfb-cart-xin">&#10003; In cart</span>';
          else if (v.available) cta = '<button class="pfb-btn pfb-btn--sm pfb-btn--navy pfb-cart-xadd" type="button" data-pf-xadd="' + v.id + '">+ Add to cart</button>';
          else cta = '<a class="pfb-btn pfb-btn--sm pfb-btn--outline pfb-cart-xadd" href="' + p.url + '">View</a>';
          return '<li class="pfb-card pfb-cart-xcard" data-variant="' + v.id + '">' +
            '<a class="pfb-well pfb-well--contain pfb-cart-ximg" href="' + p.url + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
            '<a class="pfb-cart-xtitle" href="' + p.url + '">' + escapeHtml(p.title) + '</a>' +
            '<strong class="pfb-disp pfb-cart-xprice">' + money(v.price) + '</strong>' + cta + '</li>';
        }).join('');
        box.hidden = false;
      })
      .catch(function () {});
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* Delegated events so the handlers survive re-renders. */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-pf-step]');
    if (step) {
      var input = step.parentNode.querySelector('[data-pf-qty]');
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-pf-step'), 10));
      input.value = next;
      change(parseInt(input.getAttribute('data-pf-qty'), 10), next, lineLabel(input));
      return;
    }
    var rm = e.target.closest('[data-pf-remove]');
    if (rm && window.fetch) {
      e.preventDefault();
      change(parseInt(rm.getAttribute('data-pf-remove'), 10), 0, lineLabel(rm));
      return;
    }
    var xadd = e.target.closest('[data-pf-xadd]');
    if (xadd) { add(xadd.getAttribute('data-pf-xadd'), xadd); return; }
    if (e.target.closest('[data-pf-quote-open]')) { openQuote(); return; }
    if (e.target.closest('[data-pf-quote-close]')) { closeQuote(); }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-pf-qty]');
    if (input) {
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      change(parseInt(input.getAttribute('data-pf-qty'), 10), qty, lineLabel(input));
    }
  });
  document.addEventListener('input', function (e) {
    if (e.target.closest('[data-pf-attr]')) saveAttributes();
  });
  /* Prevent Enter in a quantity box from submitting the whole cart form. */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.closest('[data-pf-qty]')) { e.preventDefault(); e.target.blur(); }
  });
  /* Make sure the last typed attributes are saved before checkout submits. */
  document.addEventListener('submit', function (e) {
    if (e.target.id === 'pfb-cart-form') { clearTimeout(attrTimer); }
  });

  function lineLabel(el) {
    var li = el.closest('.pfb-cart-line');
    var t = li && li.querySelector('.pfb-cart-title');
    return t ? t.textContent.trim() : 'Item';
  }

  function boot() {
    if (!root()) return;
    applyContinueLink();
    syncQuoteFields();
    showQuoteSent();
    loadRecommendations();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
